var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.market),function(mark,i){return _c('binary-odds',{key:`odds-${mark.id + mark.runners[0].id + i}`,attrs:{"market":_vm.market,"one-market":_vm.market[i],"runner":mark.runners[0]}})}),_vm._v(" "),_c('ladder-overlay')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }